module.exports = __webpack_public_path__ + "static/media/Witch Doctor.e34f4720.png";